import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";
import { ManagerType } from "../constants";

export default {
  path: "/account",
  redirect: "/account",
  name: "Account",
  component: LAYOUT,
  meta: {
    order: 100,
    roles: ManagerType.OrganizationReviewer,
    title: "账号管理",
  },
  children: [
    {
      path: "",
      name: "AccountPage",
      component: () => import("@/views/account/AccountPage.vue"),
      meta: {
        title: "账号管理",
        icon: "fluent-mdl2:player-settings",
        roles: ManagerType.ProjectAdmin,
      },
    },
    {
      path: ":id",
      name: "AccountDetailPage",
      component: () => import("@/views/account/AccountDetailPage.vue"),
      meta: {
        title: "账号详情",
        roles: ManagerType.OrganizationReviewer,
        hideMenu: true,
      },
    },
  ],
} as RouteRecordRaw;
